<template>
  <div
    aria-roledescription="table-header"
    class="text-gray-700"
  >
    <CarvisTableSort
      :item-description="itemDescription"
      :limit="limit"
      :limit-options="limitOptions"
      :sort-by="sortBy"
      :sort-options="sortOptions"
      @update:limit="$emit('update:limit', $event)"
      @update:sort-by="$emit('update:sortBy', $event)"
    />
    <CarvisDivider class="mb-0!" />
  </div>
</template>

<script setup lang="ts" generic="T">
defineProps<{
  limitOptions: { value: number | null; label?: string }[]
  sortOptions: { value: SortBy<T>, label: string }[]
  limit: number | null
  sortBy: SortBy<T>
  itemDescription: string
}>()

defineEmits(['update:limit', 'update:sortBy'])
</script>
